import { render, staticRenderFns } from "./outlayList.vue?vue&type=template&id=2fa03dd4&lang=pug&"
import script from "./outlayList.vue?vue&type=script&lang=js&"
export * from "./outlayList.vue?vue&type=script&lang=js&"
import style0 from "./outlayList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports